// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import './https/axios'
import Vant from 'vant'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import MetaInfo from 'vue-meta-info'
import 'lib-flexible'
import $ from 'jquery'
import {
  MessageCh
} from './i18n/lang/cn'
import {
  MessageEn
} from './i18n/lang/en'
import {
  MessageTcc
} from './i18n/lang/tcc'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import './assets/css/common.css'
import './assets/css/iiconfont.css'
import 'vant/lib/index.css'
Vue.config.productionTip = false
Vue.use(MetaInfo)
Vue.use(VueI18n) //通过插件的形式挂载
Vue.use(Vant)
Vue.use(ElementUI)
const i18n = new VueI18n({
  locale: store.state.lang || 'zh-TCC',
  messages: {
    'zh-CN': {
      ...MessageCh
    },
    'en-US': {
      ...MessageEn
    },
    'zh-TCC': {
      ...MessageTcc
    },
  },
  silentTranslationWarn: true
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log(to.meta, document)
  if (to.meta.title) {
    document.title = to.meta.title;

  }
  if (to.meta.keywords) {
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords)
  }
  if (to.meta.description) {
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description)
  }
  next();
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  ElementUI,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js